import { css } from '@emotion/css';

const modalContainer = css`
  padding: var(--spacings-5) var(--dimensions-15);

  @media (max-width: 728px) {
    padding: var(--spacings-4);
  }
`;

const newWalletModalStyles = {
  modalContainer,
};

export default newWalletModalStyles;
